import React, { Fragment } from 'react';
import { Form, Accordion, Button, Icon, Grid, Header } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { SiteComponent } from 'Common/SiteComponent';
import { DiscrepancyReportEnum } from 'Common/FieldEnum';
import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DatePickerCustomButton } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DISCREPANCY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { getDates } from 'Common/FormHelper';

import { PrintTypeEnum } from '../helper';

const DiscrepancyReportComponent = props => {
  const {
    activeIndexes,
    handleAccordionClick,
    typeOptions,
    vendorData,
    vendorDataLoading,
    typeOptionsValue,
    handleSubmit,
    onSubmit,
    reset,
  } = props;

  return (
    <Accordion fluid styled>
      <Accordion.Title
        active={!activeIndexes}
        index={0}
        onClick={handleAccordionClick}
      >
        <Icon name="dropdown" />
        <span className={'text-orange'}>Filter By</span>
      </Accordion.Title>

      <Accordion.Content active={!activeIndexes}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div style={{ paddingTop: 25 }}>
                  <Header as="h4">Site</Header>
                </div>
              </Grid.Column>

              <Grid.Column>
                <div style={{ paddingTop: 25 }}>
                  <Header as="h4">Distributor</Header>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={2}>
              <Grid.Column>
                <SiteComponent
                  label={''}
                  name={DiscrepancyReportEnum.Site}
                  isForm={true}
                  style={{ marginBottom: 10 }}
                  isAllValueZero={true}
                  isAllRequired={true}
                  selectFirst={true}
                  checkIsLicensed={false}
                  showAllActiveSites={true}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={SelectField}
                  label={''}
                  name={DiscrepancyReportEnum.Vendor}
                  options={vendorData}
                  loading={vendorDataLoading}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <div style={{ paddingTop: 25 }}>
                  <Header as="h4">Type</Header>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={1}>
              <Grid.Column
                width={10}
                style={{
                  fontSize: '0.78571429em',
                }}
              >
                <ReduxFormButtonGroup
                  options={typeOptions}
                  type={'button'}
                  formName={DISCREPANCY_REPORT_FORM_NAME}
                  fieldName={DiscrepancyReportEnum.Type}
                  label={''}
                />
              </Grid.Column>
            </Grid.Row>

            {typeOptionsValue === PrintTypeEnum.OrderedVsReceived ? (
              <Fragment>
                <Grid.Row>
                  <Grid.Column>
                    <div style={{ paddingTop: 25 }}>
                      <Header as="h4">Delivery Date Range</Header>
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={3}>
                  <Grid.Column width={4}>
                    <Field
                      component={DatePickerField}
                      label={'From:'}
                      dateFormat={DATE_FORMAT_FOR_UI}
                      name={DiscrepancyReportEnum.DateFrom}
                      dropdownMode="select"
                      customInput={<DatePickerCustomButton />}
                    />
                  </Grid.Column>

                  <Grid.Column width={4}>
                    <Field
                      component={DatePickerField}
                      label={'To:'}
                      dateFormat={DATE_FORMAT_FOR_UI}
                      name={DiscrepancyReportEnum.DateTo}
                      dropdownMode="select"
                      customInput={<DatePickerCustomButton />}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Fragment>
            ) : (
              <Fragment>
                <Grid.Row>
                  <Grid.Column>
                    <div style={{ paddingTop: 25 }}>
                      <Header as="h4">Date</Header>
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      component={DatePickerField}
                      label={''}
                      dateFormat={DATE_FORMAT_FOR_UI}
                      name={DiscrepancyReportEnum.OnHandDateTo}
                      dropdownMode="select"
                      customInput={<DatePickerCustomButton />}
                      includeDates={getDates(true)}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Fragment>
            )}

            <Grid.Row>
              <Grid.Column>
                <Button
                  className={'clear-filters-button'}
                  content="Clear Filters"
                  onClick={reset}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Accordion.Content>
    </Accordion>
  );
};

DiscrepancyReportComponent.propTypes = {
  activeIndexes: PropTypes.number,
  handleAccordionClick: PropTypes.func,
  typeOptions: PropTypes.array.isRequired,
  vendorData: PropTypes.array.isRequired,
  vendorDataLoading: PropTypes.bool,
  typeOptionsValue: PropTypes.number,
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  reset: PropTypes.func,
};

DiscrepancyReportComponent.defaultProps = {
  activeIndexes: 0,
  handleAccordionClick: () => {},
  vendorDataLoading: false,
  typeOptionsValue: PrintTypeEnum.OrderedVsReceived,
  handleSubmit: () => {},
  onSubmit: () => {},
  reset: () => {},
};

export default reduxForm({
  form: DISCREPANCY_REPORT_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(DiscrepancyReportComponent);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/discrepancyreport/components/DiscrepancyReport.js